// libraries
import clsx from 'clsx'

// svg
import { ArrowRight, Envelope, Phone, MapPin, Person, LinkedIn, ResearchGate } from '/react4xp/components/Icons/Ux'

// css
import './index.scss'

type IconType = 'arrow-right' | 'envelope' | 'phone' | 'map-pin' | 'person' | 'linkedin' | 'researchgate'

interface Props {
    href?: string
    className?: string
    label?: {
        noUnderline?: string
        underline?: string
    }
    isExternal?: boolean
    icon?: {
        type?: IconType
        iconFirst?: boolean
        iconBoth?: {
            first: IconType
            last: IconType
        }
    }
    onClick?: () => void
}

function IconSymbol({ type }: { type: IconType }) {
    return (
        <>
            {type === 'arrow-right' && <ArrowRight />}
            {type === 'envelope' && <Envelope />}
            {type === 'phone' && <Phone />}
            {type === 'map-pin' && <MapPin />}
            {type === 'person' && <Person />}
            {type === 'linkedin' && <LinkedIn />}
            {type === 'researchgate' && <ResearchGate />}
        </>
    )
}

export default function Link({
    href,
    label,
    className,
    isExternal = false,
    icon,
    onClick,
    ...props
}: Props) {
    return (
        <a
            href={href}
            target={isExternal ? '_blank' : undefined}
            rel={isExternal ? 'noopener noreferrer' : undefined}
            className={clsx(
                'custom-link',
                className,
                icon?.iconFirst && 'custom-link--icon-first',
                icon?.iconBoth && 'custom-link--icon-both'
            )}
            {...props}
            onClick={onClick}
        >

            <span data-custom-link-bg />

            <span data-custom-link-label>

                {label?.noUnderline && (
                    <span data-custom-link-label-no-underline>
                        {label.noUnderline}
                    </span>    
                )}

                {label?.underline && (
                    <span data-custom-link-label-underline>
                        {label.underline}
                    </span>
                )}

            </span>

            {icon?.iconBoth ? (
                <>
                    <span data-custom-link-icon-first>
                        <IconSymbol type={icon.iconBoth.first} />
                    </span>
                    <span data-custom-link-icon-last>
                        <IconSymbol type={icon.iconBoth.last} />
                    </span>
                </>
            ) : icon?.type && (
                <span data-custom-link-icon>
                    <IconSymbol type={icon.type} />
                </span>
            )}

        </a>
    )
}